import React, { useRef, useLayoutEffect } from 'react';

function isLinkPrefetch(el) {
  return el.tagName === 'LINK' && el.rel === 'prefetch';
}

const usePlaceholderRender = (resolveId, content) => {
  const hydrationRef = useRef(null);
  const {
    current: ssrDomNodes
  } = useRef(content || []);
  useLayoutEffect(() => {
    const element = hydrationRef.current;
    const {
      parentNode
    } = element || {};

    if (parentNode && !parentNode.contains(ssrDomNodes[0])) {
      ssrDomNodes.reverse().forEach(node => {
        // this fixes an issue with Chrome that re-triggers and cancels prefetch
        // when node is appended again, making network panel quite noisy
        if (isLinkPrefetch(node)) node.rel = '';
        parentNode.insertBefore(node, element.nextSibling);
      });
    }

    return () => {
      ssrDomNodes.forEach(node => {
        var _node$parentNode;

        return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
      });
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hydrationRef.current, ssrDomNodes]);
  return hydrationRef;
};

export const PlaceholderFallbackRender = _ref => {
  let {
    id,
    content
  } = _ref;
  const placeholderRef = usePlaceholderRender(id, content);
  return /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    "data-lazy-begin": id,
    ref: placeholderRef
  });
};